import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  PROJECTOR_TEMPLATES_FEATURE_KEY,
  ProjectorTemplatesState,
  projectorTemplatesAdapter,
} from './projector-templates.reducer'

export const selectProjectorTemplatesState = createFeatureSelector<ProjectorTemplatesState>(
  PROJECTOR_TEMPLATES_FEATURE_KEY,
)

const { selectAll: selectAllTemplates, selectEntities: selectTemplateEntities } =
  projectorTemplatesAdapter.getSelectors()

export const selectProjectorTemplatesLoaded = createSelector(selectProjectorTemplatesState, (state) => state.loaded)

export const selectProjectorTemplatesEditCreateLoaded = createSelector(
  selectProjectorTemplatesState,
  (state) => state.editCreateLoaded,
)

export const selectApplyTemplateLoaded = createSelector(
  selectProjectorTemplatesState,
  (state) => state.applyTemplateLoaded,
)

export const selectAllProjectorTemplatesList = createSelector(selectProjectorTemplatesState, (state) =>
  selectAllTemplates(state),
)

export const selectProjectorTemplateEntitiesMap = createSelector(selectProjectorTemplatesState, (state) =>
  selectTemplateEntities(state),
)

export const selectSelectedProjectorTemplateId = createSelector(
  selectProjectorTemplatesState,
  (state) => state.selectedId,
)

export const selectSelectedProjectorTemplate = createSelector(
  selectProjectorTemplateEntitiesMap,
  selectSelectedProjectorTemplateId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)
